export function gioSetUserId(userId) {
  if (window.gio) {
    window.gio('setUserId', userId);
  }
}

export function gioClearUserId() {
  if (window.gio) {
    window.gio('clearUserId');
  }
}

export function gioTrack(eventId, eventLevelVariables) {
  if (window.gio) {
    window.gio('track', eventId, eventLevelVariables);
  }
}